export default __webpack_public_path__ + "static/media/151-relax.fb903287.png";